import { SAFE_HARBOR_DISCLAIMER_STORAGE_KEY } from '@/components/modals/disclaimer-modal/constants';
import { DISCLAIMER_MODAL_NAME } from '@/components/modals/disclaimer-modal/types';
import { useModalContext } from '@/components/modals/modal-context';
import { isPhysicianSiteType } from '@/lib/utils';

type Action = () => void;

interface DisclaimerState {
  withDisclaimer: (action: Action, siteType: string) => void;
  checkDisclaimerStatus: () => boolean;
  closeModal: (name: string) => void;
  isOpen: (name: string) => boolean;
}

export const useSafeHarborDisclosure = (): DisclaimerState => {
  const { openModal, closeModal, isOpen } = useModalContext();

  const checkDisclaimerStatus = () => {
    const timestamp = localStorage.getItem(SAFE_HARBOR_DISCLAIMER_STORAGE_KEY);

    if (!timestamp) {
      // show always
      return true;
    }

    const currentTime = Date.now();
    const storedTime = timestamp ? parseInt(timestamp, 10) : NaN;

    return Number.isNaN(storedTime) || currentTime >= storedTime;
  };

  const withDisclaimer = (action: Action, siteType: string) => {
    try {
      // Note: do not show safe harbor modal on PSG sites
      const isPhysician = isPhysicianSiteType(siteType);
      if (isPhysician) {
        // skip open modal and continue
        action();
        return;
      }

      // if currentTime is later than stored or invalid
      const shouldOpenDisclaimerModal = checkDisclaimerStatus();
      if (shouldOpenDisclaimerModal) {
        openModal(DISCLAIMER_MODAL_NAME.SAFE_HARBOR);
      } else {
        action();
      }
    } catch (e: unknown) {
      console.log('Unable to show disclaimer modal.', e);
    }
  };

  return {
    withDisclaimer,
    checkDisclaimerStatus,
    closeModal,
    isOpen,
  };
};
